import httpClient from 'httpClient';

class HomeService {
  getHome() {
    return httpClient.get('/home');
  }
}

export default new HomeService();
